/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElectronSetRequiredFeaturesResult
 */
export interface ElectronSetRequiredFeaturesResult {
    /**
     * 
     * @type {number}
     * @memberof ElectronSetRequiredFeaturesResult
     */
    overwolfGameId: number;
    /**
     * 
     * @type {string}
     * @memberof ElectronSetRequiredFeaturesResult
     */
    gameName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElectronSetRequiredFeaturesResult
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElectronSetRequiredFeaturesResult
     */
    error?: string;
}

/**
 * Check if a given object implements the ElectronSetRequiredFeaturesResult interface.
 */
export function instanceOfElectronSetRequiredFeaturesResult(value: object): value is ElectronSetRequiredFeaturesResult {
    if (!('overwolfGameId' in value) || value['overwolfGameId'] === undefined) return false;
    if (!('gameName' in value) || value['gameName'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function ElectronSetRequiredFeaturesResultFromJSON(json: any): ElectronSetRequiredFeaturesResult {
    return ElectronSetRequiredFeaturesResultFromJSONTyped(json, false);
}

export function ElectronSetRequiredFeaturesResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronSetRequiredFeaturesResult {
    if (json == null) {
        return json;
    }
    return {
        
        'overwolfGameId': json['overwolfGameId'],
        'gameName': json['gameName'],
        'success': json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function ElectronSetRequiredFeaturesResultToJSON(json: any): ElectronSetRequiredFeaturesResult {
    return ElectronSetRequiredFeaturesResultToJSONTyped(json, false);
}

export function ElectronSetRequiredFeaturesResultToJSONTyped(value?: ElectronSetRequiredFeaturesResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overwolfGameId': value['overwolfGameId'],
        'gameName': value['gameName'],
        'success': value['success'],
        'error': value['error'],
    };
}

